module.exports = __webpack_public_path__ + "img/aura.0dc7fa40.png";